module.exports = __webpack_public_path__ + "static/media/7.164e0b88.jpg";